module.exports = VueLazyload;


//////////////////
// WEBPACK FOOTER
// external "VueLazyload"
// module id = puwX
// module chunks = 65